module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "channel",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.channel
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.name),
      callback: function($$v) {
        _vm.$set(_vm.channel, "name", $$v)
      },
      expression: "channel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_dParent'),
      "prop": "father"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contact'),
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.contact),
      callback: function($$v) {
        _vm.$set(_vm.channel, "contact", $$v)
      },
      expression: "channel.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contactPhone'),
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.tel),
      callback: function($$v) {
        _vm.$set(_vm.channel, "tel", $$v)
      },
      expression: "channel.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.addr),
      callback: function($$v) {
        _vm.$set(_vm.channel, "addr", $$v)
      },
      expression: "channel.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.right === '0'),
      expression: "right === '0'"
    }],
    attrs: {
      "label": _vm.$t('app_cerMgType'),
      "prop": ""
    }
  }, [(this.config.type === 1) ? _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1) : _c('span', [(_vm.channel.father && _vm.channel.father.pid !== '0') ? _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1) : _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1)])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.save('channel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3ee1d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/newChannel.vue
// module id = 980
// module chunks = 0